import styled from "styled-components";
import theme from "../../../../../styles/theme";
import { useState } from 'react';
import { IOT_TP } from "../../../../common/constants";
import { useGetInoutHistSel, useGetInoutSel } from "../../../../../interface/inout";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useEffect } from 'react';
import { Row } from "../../../../../styles/common";

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        // display: inline-box;
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        // width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
`;

const InoutMod = () => {

    const [sendParam, setSendParam] = useState({iot_tp:IOT_TP.SEARCH});
    const [sno, setSno] = useState();

    const { data: selectInoutList, isError, refetch } = useGetInoutSel(sendParam);
    const { data,  refetch: inoutHistRefetch } = useGetInoutHistSel({sno:sno});

    useEffect(()=>{
        inoutHistRefetch();
    },[sno])


    return (
        <MainWrap>
            <h3>조사변경</h3>
            <Row>
                <FormControl style={{width:'20rem'}} size='small'>
                    <InputLabel id='iotNm-label'>과업명</InputLabel>
                    <Select label="과업명" labelId='iotNm-label' size='small' value={sno}>
                        {selectInoutList && selectInoutList.map((item,index)=>{
                            return <MenuItem 
                                        key={index} 
                                        value={item.sno} 
                                        onClick={()=>setSno(item.sno)}
                                    >
                                        {item.iot_nm}
                                    </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Row>
        </MainWrap>
    )

}

export default InoutMod;